import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Helmet} from "react-helmet";

import LoginFooter from 'components/modules/footer/LoginFooter';


class CharteUtilisateur extends Component {
    constructor(props) {
      super(props);
      this.state = {
      };
    }

    changeCookieSettings = () => {
        window.Cookiebot.show();
      }

    render(){
        const {user} = this.props;

        return(
            <div className= {`paypsScene rgpdFilesScene`}>
                <Helmet>
                    <title>Payps - {window['webAppContent'].PERSONNAL_DATA.META}</title>
                    <meta name="description" content={window['webAppContent'].PERSONNAL_DATA.META} />
                </Helmet>
                <div className="titleRubrique leftAlign"><h1>{window['webAppContent'].PERSONNAL_DATA.META}</h1></div>
                <div className="version">{window['webAppContent'].PERSONNAL_DATA.DATE} 07.02.2021</div>
                <div className="texte">
                {window['webAppContent'].PERSONNAL_DATA.INTRO_TEXT_A}<br /><br />

                {window['webAppContent'].PERSONNAL_DATA.INTRO_TEXT_B}<br /><br />

                {window['webAppContent'].PERSONNAL_DATA.INTRO_TEXT_C}

                <h2>{window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TITLE}</h2>

                {window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TEXT_A}<br /><br />

                {window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TEXT_B}
                <ul>
                <li>{window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TEXT_C}</li>
                <li>{window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TEXT_D}</li>
                <li>{window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TEXT_E}</li>
                <li>{window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TEXT_F}</li>
                </ul>
                {window['webAppContent'].PERSONNAL_DATA.WHAT_IS_TEXT_G}
                
                <h2>1. {window['webAppContent'].PERSONNAL_DATA.RESPECT_TITLE}</h2>
                {window['webAppContent'].PERSONNAL_DATA.RESPECT_TEXT_A}<br /><br />

                {window['webAppContent'].PERSONNAL_DATA.RESPECT_TEXT_B}<br />
                {window['webAppContent'].PERSONNAL_DATA.RESPECT_TEXT_C}

                <h2>2. {window['webAppContent'].PERSONNAL_DATA.TRANSPARENCY_TITLE}</h2>
                {window['webAppContent'].PERSONNAL_DATA.TRANSPARENCY_TEXT_A}<br /><br />

                {window['webAppContent'].PERSONNAL_DATA.TRANSPARENCY_TEXT_B}<br /><br />

                {window['webAppContent'].PERSONNAL_DATA.TRANSPARENCY_TEXT_C}

                <h2>3. {window['webAppContent'].PERSONNAL_DATA.CONFIDENTIALITY_TITLE}</h2>
                {window['webAppContent'].PERSONNAL_DATA.CONFIDENTIALITY_TEXT_A}

                <h2>4. {window['webAppContent'].PERSONNAL_DATA.SECURITY_TITLE}</h2>
                {window['webAppContent'].PERSONNAL_DATA.SECURITY_TEXT_A}<br /><br />

                {window['webAppContent'].PERSONNAL_DATA.SECURITY_TEXT_B}
                <ul>
                    <li>{window['webAppContent'].PERSONNAL_DATA.SECURITY_TEXT_C}</li>
                    <li>{window['webAppContent'].PERSONNAL_DATA.SECURITY_TEXT_D}</li>
                    <li>{window['webAppContent'].PERSONNAL_DATA.SECURITY_TEXT_E}</li>
                </ul>                              
        </div>
                {
                    !user && 
                    <LoginFooter creation={true} showOffers={true} identification={true} />
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { loading, errorMessage, user} = state.authentication;
    return {
        loading,
        errorMessage,
        user,
    };
}

export default connect(mapStateToProps)(CharteUtilisateur); 